import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../ConfigFields/SelectField';

const ON_COLLISION_OPTIONS = [
  { value: 'Overwrite', label: 'Overwrite' },
  { value: 'Error', label: 'Fail' },
];

export function ExportToSftpFormFields() {
  return (
    <>
      <BlockValueTemplateField
        fieldName="config.fileReference"
        label="File Reference"
        required
        helperText="Reference to the file to export, usually a `fileReference` value from an earlier block (e.g. `{{generateDocument.data.fileReference}}`). Templating is supported."
      />
      <BlockValueTemplateField
        fieldName="config.directory"
        label="Directory"
        required
        helperText="Destination directory on the SFTP host, relative to your organization's folder. Files land at `<your-org>/<directory>/<filename>`."
      />
      <BlockValueTemplateField
        fieldName="config.filename"
        label="Filename"
        required
        helperText="Name to write the file under (e.g. `claim-2026-01-15.pdf`)."
      />
      <BlockSelectField
        fieldName="config.onCollision"
        label="Conflict resolution"
        options={ON_COLLISION_OPTIONS}
        defaultValue="Overwrite"
        helperText="What to do if a file already exists at the destination."
      />
    </>
  );
}
